import { createAction } from 'shared';

export const fetchApplications = createAction('FETCH_APPLICATIONS_SUCCESS', 'ids', 'entities');
